import { createContextEvent } from '../create-custom-event';

export const UPDATE_SELECTED_SITE_ACTION = 'UPDATE_SELECTED_SITE_ACTION' as const;
export type UpdateSelectedSiteAction = typeof UPDATE_SELECTED_SITE_ACTION;

export interface IUpdateSelectedSiteAction {
  selectedSiteId: string;
}

export type UpdateSelectedSiteEvent = CustomEvent<IUpdateSelectedSiteAction>;

export function createSelectedSiteActionEvent(selectedSiteId: string): UpdateSelectedSiteEvent {
  return createContextEvent({ eventType: UPDATE_SELECTED_SITE_ACTION, eventDetail: { selectedSiteId } });
}
